import styled from 'styled-components';

export const ItemWrapper = styled.div`
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  z-index: 0;
  &:hover {
    z-index: 2;
  }
`;

export default ItemWrapper;
